import {
  titleWithTag,
  form0781HeadingTag,
  mentalHealthSupportAlert,
} from '../content';
import {
  behaviorSummaryPageTitle,
  summarizeBehaviors,
} from '../content/behaviorListPages';

export const uiSchema = {
  'ui:title': titleWithTag(behaviorSummaryPageTitle, form0781HeadingTag),
  'ui:description': ({ formData }) => summarizeBehaviors(formData),
  'view:mentalHealthSupportAlert': {
    'ui:description': mentalHealthSupportAlert,
  },
};
export const schema = {
  type: 'object',
  properties: {
    'view:mentalHealthSupportAlert': {
      type: 'object',
      properties: {},
    },
  },
};
